import type React from "react";

interface CardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export default function Card({ title, children, className = "" }: CardProps) {
  return (
    <div className={`bg-white rounded-2xl border border-stone-100 shadow-sm ${className}`}>
      <div className="px-5 pt-5 pb-1">
        <p className="text-xs font-bold tracking-widest uppercase text-stone-400 mb-4">{title}</p>
      </div>
      <div className="px-5 pb-5">{children}</div>
    </div>
  );
}
